module.exports = __webpack_public_path__ + "static/blog-13-b134f60ac4c10c807b188c0fe6ea3b46.png";